var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
import { defineComponent, createVNode, createTextVNode, mergeProps } from "vue";
import { getPrefixCls } from "../_utils/global-config.js";
import { SHAPES } from "./constants.js";
import _Avatar from "./avatar.js";
import Popover from "../popover/index.js";
var _AvatarGroup = defineComponent({
  name: "AvatarGroup",
  components: {
    Avatar: _Avatar,
    Popover
  },
  props: {
    shape: {
      type: String,
      default: "circle",
      validator: (value) => {
        return SHAPES.includes(value);
      }
    },
    size: Number,
    autoFixFontSize: {
      type: Boolean,
      default: true
    },
    maxCount: {
      type: Number
    },
    zIndexAscend: {
      type: Boolean,
      default: false
    },
    maxStyle: {
      type: Object
    },
    maxPopoverTriggerProps: {
      type: Object
    }
  },
  setup(props, {
    slots
  }) {
    const prefixCls = getPrefixCls("avatar-group");
    return () => {
      var _a, _b;
      const children = (_b = (_a = slots.default) == null ? void 0 : _a.call(slots)) != null ? _b : [];
      const count = children.length;
      let avatarsToRender = children;
      if (props.maxCount != null && count > props.maxCount) {
        const avatarsInPopover = children.slice(props.maxCount);
        avatarsToRender = children.slice(0, props.maxCount);
        avatarsToRender.push(createVNode(Popover, __spreadValues({}, props.maxPopoverTriggerProps), {
          content: () => createVNode("div", null, [avatarsInPopover]),
          default: () => createVNode(_Avatar, {
            key: "_arco_avatar_group_popup",
            class: `${prefixCls}-max-count-avatar`,
            style: props.maxStyle,
            size: props.size
          }, () => createVNode("div", null, [createTextVNode("+"), avatarsInPopover.length]))
        }));
      }
      return createVNode("div", {
        "class": prefixCls
      }, [avatarsToRender.map((item, index) => {
        const stackedStyle = {
          zIndex: props.zIndexAscend ? index + 1 : count - index,
          marginLeft: props.size ? index !== 0 ? `-${props.size / 4}px` : "0px" : ""
        };
        item.props = mergeProps({
          size: props.size,
          shape: props.shape,
          autoFixFontSize: props.autoFixFontSize,
          style: stackedStyle
        }, item.props || {});
        return item;
      })]);
    };
  }
});
export { _AvatarGroup as default };
